import { defineMessages } from 'react-intl';

const scope = 'dashboard.outbox';

const messages = defineMessages({
  deleteConfirmDialogTotal: {
    id: `${scope}.DeleteConfirmDialog.total`,
    defaultMessage: '임시보관된 모든 가정통신문을 삭제하시겠습니까?',
  },
  deleteConfirmDialogChecked: {
    id: `${scope}.DeleteConfirmDialog.checked`,
    defaultMessage: '임시보관된 { count }개의 가정통신문을 삭제하시겠습니까?',
  },
  deleteConfirmDialogCancelButton: {
    id: `${scope}.DeleteConfirmDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteConfirmDialogDeleteButton: {
    id: `${scope}.DeleteConfirmDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteConfirmDialogDeleteButtonAll: {
    id: `${scope}.DeleteConfirmDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmDialogDeleteButton: {
    id: `${scope}.DeleteReconfirmDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteReconfirmDialogDeleteButtonAll: {
    id: `${scope}.DeleteReconfirmDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmDialogCancelButton: {
    id: `${scope}.DeleteReconfirmDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteReconfirmDialog: {
    id: `${scope}.DeleteReconfirmDialog`,
    defaultMessage: '정말 삭제하시겠습니까?{ br }삭제한 가정통신문은 복구할 수 없습니다.',
  },
  outboxHeading: {
    id: `${scope}.Outbox.Heading`,
    defaultMessage: '임시보관함',
  },
  outboxSearchFieldPlaceholder: {
    id: `${scope}.Outbox.SearchField.placeholder`,
    defaultMessage: '번호, 제목, 작성자 검색',
  },
  draftTableHeadNumber: {
    id: `${scope}.DraftTable.head.number`,
    defaultMessage: '번호',
  },
  draftTableHeadTitle: {
    id: `${scope}.DraftTable.head.title`,
    defaultMessage: '제목',
  },
  draftTableHeadWriter: {
    id: `${scope}.DraftTable.head.writer`,
    defaultMessage: '작성자',
  },
  draftTableHeadSaveAt: {
    id: `${scope}.DraftTable.head.saveAt`,
    defaultMessage: '수정시간',
  },
  draftTableBodyNumber: {
    id: `${scope}.DraftTable.body.number`,
    defaultMessage: '제{ year }-{ issueNumber }호',
  },
  draftTableBodyMark: {
    id: `${scope}.DraftTable.body.mark`,
    defaultMessage: '작성 중',
  },
  draftTableBodyTitleNoData: {
    id: `${scope}.DraftTable.body.title.noData`,
    defaultMessage: '제목 없음',
  },
  draftTableFallbackMessageFiltered: {
    id: `${scope}.DraftTable.fallbackMessage.filtered`,
    defaultMessage: '해당하는 가정통신문이 없습니다. 필터를 다시 설정해보세요.',
  },
  draftTableFallbackMessageNoData: {
    id: `${scope}.DraftTable.fallbackMessage.noData`,
    defaultMessage: '임시보관된 가정통신문이 없습니다.',
  },
  rowsPerPageFilterLabel: {
    id: `${scope}.RowsPerPageFilter.label`,
    defaultMessage: '{ num }개씩 보기',
  },
  tableToolBarUnselectButton: {
    id: `${scope}.TableToolBar.UnselectButton`,
    defaultMessage: '선택 해제',
  },
  tableToolBarSelectButton: {
    id: `${scope}.TableToolBar.SelectButton`,
    defaultMessage: '전체 선택',
  },
  tableToolBarDeleteButton: {
    id: `${scope}.TableToolBar.DeleteButton`,
    defaultMessage: '선택 삭제',
  },
  tableToolBarSelectInfo: {
    id: `${scope}.TableToolBar.SelectInfo`,
    defaultMessage: '{ count }개 선택됨',
  },
  tableToolBarSelectInfoAll: {
    id: `${scope}.TableToolBar.SelectInfo.all`,
    defaultMessage: '전체 선택됨',
  },
  yearFilterLabel: {
    id: `${scope}.YearFilter.label`,
    defaultMessage: '{ year }년도',
  },
  yearFilterLabelAll: {
    id: `${scope}.YearFilter.label.all`,
    defaultMessage: '전체 보기',
  },
  yearFilterSelectLabel: {
    id: `${scope}.YearFilter.Select.label`,
    defaultMessage: '연도',
  },
});

export default messages;
